import classNames from 'classnames';
import WarningIcon from '@images/svg/warning.svg?react';
import { FC } from 'react';
import useFetchMaintenanceMessage from '@components/features/maintenanceMessage/hooks/useFetchMaintenanceMessage';
import { useTranslation } from 'react-i18next';
import { LocaleKey } from '@models/Locales';

interface Props {
    className?: string;
}

const MaintenanceMessage: FC<Props> = ({ className }) => {
    const { i18n } = useTranslation();
    const language = i18n.language as LocaleKey;
    const { data } = useFetchMaintenanceMessage();

    if (!data?.messages?.length) {
        return null;
    }

    const now = new Date();

    const activeMessage = data.messages.find((message) => {
        const showFrom = new Date(message.showFrom);
        const showTo = new Date(message.showTo);

        return now >= showFrom && now <= showTo;
    });

    if (!activeMessage) {
        return null;
    }

    const formatTime = (date: Date, locale: string) =>
        new Intl.DateTimeFormat(locale, {
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);

    const formatDate = (date: Date, locale: string) =>
        new Intl.DateTimeFormat(locale, {
            day: 'numeric',
            month: 'long',
        }).format(date);

    const content = activeMessage.content[language]
        .replaceAll('$DATE$', formatDate(new Date(activeMessage.from), language))
        .replaceAll('$FROM$', formatTime(new Date(activeMessage.from), language))
        .replaceAll('$TO$', formatTime(new Date(activeMessage.to), language));

    return (
        <div className={classNames('maintenanceMessage', className)}>
            <h2 className="maintenanceMessage__heading">
                <WarningIcon className="maintenanceMessage__icon" aria-hidden="true" />
                {activeMessage.title[language]}
            </h2>
            <p className="maintenanceMessage__content">{content}</p>
        </div>
    );
};

export default MaintenanceMessage;
